jQuery(document).ready(function($){
	console.log('DNS Tags Theme');

	$('.tag-list-item .tag-title').on('click', function(e){
		if(!$(e.target).hasClass('title')) {
			$(this).closest('.tag-list-item').toggleClass('expanded');
			loadTagImage($(this).closest('.tag-list-item'));
		}
	});

	$('.show-search-filters').on('click', function(){
		$(this).closest('form').toggleClass('expanded');
	});

	$('.tag-list-item.expanded').each(function(){
		loadTagImage($(this));
	});

	function loadTagImage(el) {
		el.find('.tag-meta.load-image').each(function(){
			let imgDiv = $(this);
			if(!imgDiv.hasClass('loaded')) {
				const url = $(this).attr('img-src');
				const imgMarkup = '<img src="' + url + '">';
				imgDiv.html(imgMarkup).addClass('loaded');
			}
		});
	}
});